import cx from "classnames";
import React from "react";
import "./PersonalisationHeading.css";

interface PersonalisationHeadingProps {
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xs";
  customSize?: string;
  weight?: 400 | 500;
  className?: string;
}

export const PersonalisationHeading = ({
  children,
  size = "lg",
  customSize,
  weight = 400,
  className = "",
}: PersonalisationHeadingProps) => {
  const sizeClasses = {
    sm: "personalisation-heading-sm",
    md: "personalisation-heading-md",
    lg: "personalisation-heading-lg",
    xs: "personalisation-heading-xs",
  };

  const weightClass = weight === 500 ? "font-medium" : "font-normal";

  // Use custom size if provided, otherwise use predefined size
  const sizeClass = customSize ? "" : sizeClasses[size];
  const style = customSize
    ? { fontSize: customSize, lineHeight: "1.2" }
    : undefined;

  return (
    <h1
      className={cx(
        "font-serif italic tracking-[0.02em]",
        weightClass,
        sizeClass,
        className
      )}
      style={style}
    >
      {children}
    </h1>
  );
};
